export const onFiltersChange = ({
  newSelectedFilters,
  campaignsList,
  setFilteredCampaignsList,
  isSelfServeEnabled,
  sortByValue,
  sortData,
  sortDirection,
}) => {
  const campaignListCopy = JSON.parse(JSON.stringify(campaignsList))
  let newFilteredList = [...campaignListCopy]
  Object.entries(newSelectedFilters).forEach(([key, value]) => {
    if (key === 'types' && value) {
      newFilteredList = newFilteredList.filter(
        campaign => campaign.type === value,
      )
    } else if (
      key === 'statuses' &&
      value.length &&
      value[value.length - 1] !== null
    ) {
      if (!isSelfServeEnabled) {
        newFilteredList = newFilteredList.filter(campaign =>
          value.includes(campaign.status),
        )
      } else {
        newFilteredList = newFilteredList.filter(campaign => {
          if (
            campaign.selfServeData[0] &&
            campaign.selfServeData[0].internalStatus
          ) {
            return value
              .flat()
              .includes(campaign.selfServeData[0].internalStatus)
          } else {
            return value.flat().includes(campaign.status)
          }
        })
      }
    }
  })

  setFilteredCampaignsList(
    sortData(newFilteredList, sortByValue, sortDirection),
  )
}
